import { render, staticRenderFns } from "./crossCheckItemsComparision.vue?vue&type=template&id=46a832ac&scoped=true&"
import script from "./crossCheckItemsComparision.vue?vue&type=script&lang=js&"
export * from "./crossCheckItemsComparision.vue?vue&type=script&lang=js&"
import style0 from "./crossCheckItemsComparision.vue?vue&type=style&index=0&id=46a832ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a832ac",
  null
  
)

export default component.exports